import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../Context";
import { useContext, useState } from "react";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LanguageIcon from "@mui/icons-material/Language";
import PersonIcon from "@mui/icons-material/Person";
import UserMenuItem from "../UserAvatarButton/UserMenuItem";
import ImpersonateUserModal from "../ImpersonateUserModal";

const AdminMenu = ({ isMedidas }) => {
  const { t, i18n } = useTranslation("Navigation");
  const { toggleThemeMode } = useContext(GlobalContext);

  const [openImpersonateModal, setOpenImpersonateModal] = useState(false);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const handleLangToggle = () => {
    i18n.changeLanguage(i18n.resolvedLanguage === "fr" ? "en" : "fr");
  };

  const handleThemeToggle = () => {
    toggleThemeMode();
  };

  const handleModalOpen = () => {
    setOpenImpersonateModal(true);
  };
  const handleModalClose = () => {
    setOpenImpersonateModal(false);
  };

  return (
    <Box sx={containerStyle}>
      {isMedidas && (
        <>
          <UserMenuItem
            icon={<LanguageIcon />}
            text={t("toggleLanguage")}
            onClick={handleLangToggle}
          />
          <UserMenuItem
            icon={<DarkModeIcon />}
            text={t("toggleTheme")}
            onClick={handleThemeToggle}
          />
          <UserMenuItem
            icon={<PersonIcon />}
            text={"Impersonate User"}
            onClick={handleModalOpen}
          />
        </>
      )}
      <ImpersonateUserModal
        open={openImpersonateModal}
        onClose={handleModalClose}
      />
    </Box>
  );
};

export default AdminMenu;
